/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../app.common.directives.module.ts" />
/// <reference path="validatorbase.ts" />
/// <reference path="validateargs.ts" />
/// <reference path="../../services/globalsettingsservice.ts" />

module App.Common.Directives {
	'use strict';

	export class StrongPassword extends ValidatorBase {

		constructor() {
			super();
		}

		public name = 'strong-password';

		public isValid = (args: Directives.ValidateArgs) => {

			var password = args.viewValue();

			if (!password || password.length < 8 || password.length > 30 || password.indexOf('"') > -1) { return false; }

			var charsetCount = 0;
			if (/[A-Z]/.test(password)) { charsetCount++; }
			if (/[a-z]/.test(password)) { charsetCount++; }
			if (/[0-9]/.test(password)) { charsetCount++; }
			if (/[^A-Za-z0-9]/.test(password)) { charsetCount++; }

			return charsetCount >= 3;
		};

		public resolveMessage = (): string => {
			return 'Your password does not meet the complexity requirements';
		};
	}

	function factory() {
		return new StrongPassword();
	}

	angular
		.module('app.common.directives')
		.directive('strongPassword', factory);

}